import React, { useEffect } from 'react';
import { InformationPanel } from '@gerdau/hefesto-mais-web/InformationPanel';
import { Button, Icon } from '@gerdau/hefesto';
import { Variants } from '@gerdau/hefesto/_shared/types';
import { useDispatch } from 'react-redux';
import {
  downloadNFFile,
  loadNFFileFromFabricationOrderDelivery
} from '../../../../../store/ducks/fabrication-orders/actions';
import {
  IDownloadNFEResponse,
  IFabricationOrderDelivery
} from '../../../../../store/ducks/fabrication-orders/types';
import { ECustomerTypeView } from '../../../../../store/ducks/user/types';
import { ContainerButtonPanel } from './styles';
import {
  RcaKind,
  sendRcaLogs
} from '../../../../../store/ducks/observability/actions';

interface IOptions {
  text: string;
  handleOnClick: () => void;
  icon?: JSX.Element;
  variant?: Extract<Variants, 'danger' | 'primary'>;
  disabled?: boolean;
}

interface INFEColumnProps {
  item: IFabricationOrderDelivery;
  contractNumber: string;
  fabricationOrderId: number;
  customerId: string;
  customerViewType: ECustomerTypeView;
}

const NFEColumn: React.FC<INFEColumnProps> = ({
  item,
  contractNumber,
  fabricationOrderId
}) => {
  const dispatch = useDispatch();

  const downloadFromUseEffect = () => {
    dispatch(
      downloadNFFile(
        fabricationOrderId,
        item.deliveryId,
        item.nfState?.downloadNFEResponse as IDownloadNFEResponse
      )
    );
    dispatch(
      sendRcaLogs(
        RcaKind.DownloadItem,
        'NFF',
        `${fabricationOrderId}:${item.deliveryId}`
      )
    );
    downloadFile(item.nfState?.downloadNFEResponse as IDownloadNFEResponse);
  };

  useEffect(() => {
    if (
      item.nfState &&
      !item.nfState.alreadyDownloaded &&
      item.nfState.downloadNFEResponse &&
      item.nfState?.downloadNFEResponse?.FILE !== ''
    ) {
      downloadFromUseEffect();
    }
  }, [item.nfState?.downloadNFEResponse]);

  const downloadNFE = () => {
    if (!item.invoices || item.invoices.length === 0) {
      return;
    }

    if (item.nfState?.downloadNFEResponse) {
      downloadFile(item.nfState.downloadNFEResponse);
      return;
    }

    dispatch(
      loadNFFileFromFabricationOrderDelivery(
        fabricationOrderId,
        item.deliveryId,
        item.invoices[item.invoices.length - 1].danfeNumber
      )
    );
    dispatch(
      sendRcaLogs(
        RcaKind.DownloadItem,
        'NFE',
        `${fabricationOrderId}:${item.deliveryId}`
      )
    );
  };

  const downloadFile = (downloadNFEResponse: IDownloadNFEResponse) => {
    const dataurl = 'data:text/plain;base64,' + downloadNFEResponse.FILE;
    const element = document.createElement('a');
    element.setAttribute('href', dataurl);
    element.setAttribute(
      'download',
      `NF-${contractNumber}-${item.deliveryId}.pdf`
    );
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const awaitingIssuance = (): boolean => {
    return (
      !item.invoices ||
      item.invoices.length === 0 ||
      item.nfState?.downloadNFEResponse?.FILE === ''
    );
  };

  const options: IOptions[] = [
    {
      text: 'Baixar nota fiscal',
      handleOnClick: downloadNFE,
      variant: 'primary',
      disabled: awaitingIssuance() || item.nfState?.loading
    }
  ];

  return (
    <InformationPanel
      title="Documentos"
      position="bottom right"
      panelOptions={options}
      trigger={
        <ContainerButtonPanel>
          <Button
            name="documents"
            variant="tertiary"
            loading={item.nfState?.loading || false}
            icon={<Icon option="MoreVertical"></Icon>}
          ></Button>
        </ContainerButtonPanel>
      }
    ></InformationPanel>
  );
};

export default NFEColumn;
